import React, { Component } from "react";
import * as actions from '../redux/time_off_actions';
import * as summaryActions from '../redux/time_off_summary_actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SectionContainer } from "../../common/SectionContainer";
import { default as TimeOffRequestModal } from '../Modals/TimeOffRequestModal';
import { default as TimeOffRequestTable } from './TimeOffRequestTable';
import { default as AgentTimeOffSummary } from './AgentTimeOffSummary';
import { DATETIME_FORMAT } from "../redux/constants";

export class AgentTimeOff extends Component {
    constructor(props) {
		super(props);
        
        let { User } = this.props;

        if(this.props.actions.fetchNextAccrualDateAction) {
			this.props.actions.fetchNextAccrualDateAction({ agentID: User.userID});
        }
        
        //bind methods
        this.toggleModal = this.toggleModal.bind(this);
        this.showEditModal = this.showEditModal.bind(this);
        this.fetchTimeOffRequests = this.fetchTimeOffRequests.bind(this);
         
        //set local state
        this.state = {
            showModal: false,
            timeOffRequest: null,
            timeOffRequestsLength: 0,
            NextAccrualDate: null
        }
    }

    componentWillReceiveProps(nextProps) {
        
        //this is used to re render the agent time off summary component when a new time off request is submitted, to ensure summary data is up to date.
        if(this.props.CurrentRequests !== nextProps.CurrentRequests) {
            this.setState({
                timeOffRequestsLength: nextProps.CurrentRequests.length
            })
        }

        if(this.props.NextAccrualDate !== nextProps.NextAccrualDate) {
            this.setState({
                NextAccrualDate: nextProps.NextAccrualDate.local().format(DATETIME_FORMAT)
            })
        }
    }

    toggleModal() {
        let isModalClosing = this.state.showModal;
        if (isModalClosing) {
            this.fetchTimeOffRequests();
        }

		this.setState({ 
            showModal: !this.state.showModal,
            timeOffRequest: null
		});
    } 
    
    showEditModal(rowData) {
        this.setState({ 
            showModal: true,
            timeOffRequest: rowData,            
		});
    }

    fetchTimeOffRequests() {
        let { User } = this.props;
        if (!User) return;
        var requestParams = {
            Page: 1,
            PageSize: 9999,
            SortOrder: 'desc',
            SortColumn: 'DateCreated',
            customFilters: [
                { "PropertyName": "AgentId", "Operation": 1, "Value": User.userID }
            ]
        }
        if(this.props.actions.fetchCurrentRequestsAction) {
            this.props.actions.fetchCurrentRequestsAction(requestParams);
        }
    }

    render() {
            let { timeOffRequest, showModal, NextAccrualDate } = this.state;
            return (
                <div>
                    <TimeOffRequestModal 
                        timeOffRequest={timeOffRequest} 
                        showModal={showModal}                         
                        toggleModal={() => this.toggleModal()}/>
                    
                    <SectionContainer className="summary-request-grid" titleText="Summary" textRight={"Next PTO accrual date: " + NextAccrualDate}>
                        <AgentTimeOffSummary key={timeOffRequest !== null ? timeOffRequest : this.state.timeOffRequestsLength } />
                    </SectionContainer>
                    
                    <SectionContainer className="timeoff-request-grid" titleText="Time Off Requests">
                        <div className="timeoff-request-grid-top-container">
                            <button className="cf-button cf-button-blue" type="button" onClick={this.toggleModal}>Request Time Off</button>
                            <TimeOffRequestTable editTimeOffRequestOnClick={this.showEditModal} />
                        </div>
                    </SectionContainer>
                </div>
            );
        }
    }

function mapStateToProps(state) {
	return {
        User: state.common.user,
        TimeOffEnumItems: state.timeoff.TimeOffEnumItems,
        CurrentRequests: state.timeoff.CurrentRequests,
        NextAccrualDate: state.timeoff.NextAccrualDate
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...summaryActions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AgentTimeOff);


// WEBPACK FOOTER //
// ./src/features/timeoff/TimeOff/AgentTimeOff.js